export default {
  title: 'Inställningar',
  showApartmentInLaundry: 'Visa lägenhetsnummer i tvättbokningen',
  SHOW_APARTMENT_IN_LAUNDRY_DESCRIPTION: 'När denna inställning är avstängd kommer lägenhetsnummer och adress att döljas i tvättbokningen för alla användare.'
} 


// WEBPACK FOOTER //
// ./src/components/pages/Settings/strings.js